import Vue from 'vue';
import Portal from 'portal-vue';

Vue.use(Portal);
